import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Select, Row, Col } from 'antd';
import ReactCountryFlag from 'react-country-flag';
import {
  filter,
  forEach,
  indexOf,
  compact,
  find,
  map,
  uniqBy,
  orderBy,
  groupBy,
  forIn,
  toString,
  cloneDeep,
  remove
} from 'lodash';

import { StyledSelect } from 'components/Styled';
import stringSimilarity from 'string-similarity';
import countriesDetail from 'data/countriesDetail';

const { Option, OptGroup } = Select;

const displayOrder = {
  Hot: 1,
  Asia: 2,
  Europe: 3,
  Oceania: 4,
  'North America': 5,
  'South America': 6,
  Africa: 7
};

class CountrySelect extends Component {
  state = {
    value: '',
    lang: ''
  };

  hotList = [
    'HK',
    'JP',
    'US',
    'GB',
    'KR',
    'AU',
    'TW',
    // 'CN',
    'TH',
    'MY',
    'CA',
    'VN',
    'BE',
    'CZ',
    'DK',
    'FR',
    'DE',
    'IN',
    'ID',
    'IT',
    'NL',
    'NZ',
    'SG',
    'ES'
  ];

  renderOptions = dataSource => {
    return dataSource.map(group => (
      <OptGroup key={group.title} label={<span>{group.title}</span>}>
        {group.children.map(opt => (
          <Option
            key={opt.alpha2}
            value={opt.alpha2}
            display={opt.name[this.props.t('key')]}>
            <Row type="flex">
              <Col>
                <ReactCountryFlag
                  countryCode={opt.alpha2}
                  style={{ width: 20, height: 20, padding: '0 8px 4px 0' }}
                  svg
                />
              </Col>
              <Col style={{ flex: 1 }}>
                {opt.name[this.props.t('key')]}
                {this.props.t('key') !== 'en' && (
                  <div style={{ fontSize: '12px', marginTop: '-8px' }}>
                    {opt.name.en}
                  </div>
                )}
              </Col>
            </Row>
          </Option>
        ))}
      </OptGroup>
    ));
  };

  handleSearch = searchText => {
    searchText = toString(searchText);

    let intermediate;
    let dataSource = [];

    if (searchText) {
      intermediate = forEach(this.matchList, x => {
        // add a underscore to add matching score at start
        const similarity = stringSimilarity.compareTwoStrings(
          `_${x.match}`.toLowerCase(),
          `_${searchText}`.toLowerCase()
        );

        x.similarity = similarity;

        if (indexOf(this.hotList, x.alpha2) !== -1) x.continent = 'Hot';

        x.displayOrder = displayOrder[x.continent];
      });

      const score = 0.3;

      // hot countries show at top even with low score
      intermediate = orderBy(
        filter(intermediate, x => x.similarity > score),
        ['displayOrder', 'similarity'],
        ['asc', 'desc']
      );

      intermediate = groupBy(
        uniqBy(intermediate, x => {
          return x.alpha2;
        }),
        'continent'
      );

      forIn(intermediate, (value, key) => {
        dataSource.push({
          title: this.props.t(`quotation.countries.${key}`),
          children: value
        });
      });

      dataSource = this.renderOptions(dataSource);
    } else {
      dataSource = this.fullOptions;
    }

    this.setState({
      dataSource
    });
  };

  handleChange = value => {
    this.setState({ value });
    this.props.handleChange(value || '');
  };

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      const value = this.state.dataSource[0].props.children[0].key;
      this.setState({ value });
      this.props.handleChange(value || '');
    }
  };

  getFullOptions = () => {
    const countries = cloneDeep(this.props.countries);

    // allow RU
    // samson@booknstore.com
    if (
      this.props.user !== 'd8a9cc31-ece4-4c16-ba8b-143dfd207fd4' &&
      this.props.user !== 'c9afa558-bc0d-4979-82a2-0ea862887856'
    ) {
      remove(countries, x => x['alpha-2'] === 'RU');
    }

    let intermediate = forEach(countries, x => {
      if (indexOf(this.hotList, x['alpha-2']) !== -1) x.continent = 'Hot';
      x.displayOrder = displayOrder[x.continent];
    });

    intermediate = orderBy(countries, 'displayOrder', 'asc');

    intermediate = groupBy(
      map(intermediate, x => {
        return {
          alpha2: x['alpha-2'],
          continent: x.continent,
          name: x.name
        };
      }),
      'continent'
    );

    const dataSource = [];

    forIn(intermediate, (value, key) => {
      if (key === 'Hot')
        value = orderBy(value, x => indexOf(this.hotList, x.alpha2), 'asc');
      dataSource.push({
        title: this.props.t(`quotation.countries.${key}`),
        children: value
      });
    });

    return this.renderOptions(dataSource);
  };

  matchList = [];

  countriesInit = () => {
    // prepare countries name data
    const countries = this.props.countries;

    // allow RU
    // samson@booknstore.com
    if (
      this.props.user !== 'd8a9cc31-ece4-4c16-ba8b-143dfd207fd4' &&
      this.props.user !== 'c9afa558-bc0d-4979-82a2-0ea862887856'
    ) {
      remove(countries, x => x['alpha-2'] === 'RU');
    }

    this.matchList = [];

    forEach(countries, c => {
      const detail = find(countriesDetail, ['ISO.alpha2', c['alpha-2']]);
      const alpha2 = c['alpha-2'];
      const continent = c.continent;
      const name = c.name;

      this.matchList.push({
        alpha2,
        continent,
        name,
        match: c.name.en
      });

      this.matchList.push({
        alpha2,
        continent,
        name,
        match: c.name.zh
      });

      if (detail) {
        detail.name = detail.name || '';
        detail.altSpellings = detail.altSpellings || [];

        const items = map([detail.name, ...detail.altSpellings], match => {
          if (!match) return;

          return {
            alpha2,
            continent,
            name,
            match
          };
        });

        this.matchList.push(...compact(items));
      }
    });

    // enable all options
    this.fullOptions = this.getFullOptions();

    this.setState({ value: this.props.value });
    this.handleSearch();
  };

  componentDidMount() {
    this.countriesInit();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
      this.handleSearch();
    }

    if (prevProps.countries !== this.props.countries) {
      this.countriesInit();
    }
  }

  render() {
    return (
      <Form.Item
        style={{
          marginBottom: 0
        }}
        validateStatus={this.props.validateStatus || ''}>
        <StyledSelect
          showSearch
          value={this.state.value}
          defaultActiveFirstOption={false}
          showArrow={false}
          filterOption={false}
          optionLabelProp="display"
          onSearch={this.handleSearch}
          onChange={this.handleChange}
          notFoundContent={null}
          size="large"
          onDropdownVisibleChange={open => {
            setTimeout(() => {
              if (open) {
                document
                  .querySelectorAll('.ant-select-dropdown-menu')
                  .forEach(function (x) {
                    x.scrollTop = 0;
                  });
              }
            }, 0);
          }}
          onKeyDown={this.handleKeyDown}>
          {this.state.dataSource}
        </StyledSelect>
      </Form.Item>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user || false
  };
};

export default connect(mapStateToProps)(CountrySelect);
